// extracted by mini-css-extract-plugin
export default {"userSelectNone":"ScreenReaderHeading-module__userSelectNone--vlUbc"};